import IconModule from './iconModule.vue'
import IconPart from './index.vue'
import { isObject } from '@/util/util'
export default {
  data () {
    return {
      activeCol: -1,
      activeApp: -1
    }
  },
  components: {
    IconModule,
    IconPart
  },
  methods: {
    openIcon (val, i, j, isDefault = false) {
      this.iconType = 'apply'
      this.activeCol = i
      this.activeApp = j
      const config = this.isObject(val) ? JSON.parse(JSON.stringify(val)) : undefined
      this.$refs.iconpart.open(config, isDefault)
    },
    isObject (obj) {
      return isObject(obj)
    }
  }
}